import axios from "axios";

const BASE = "case-manual-movs";

export const searchByTicket = async (ticket) => {
  const response = await axios.get(`${BASE}/search-by-ticket/${encodeURIComponent(ticket)}`);
  return response.data;
};

export const moveCaseStatus = async (payload) => {
  const response = await axios.post(BASE, payload);
  return response.data;
};

export const getMovementsByCase = async (caseId) => {
  const response = await axios.get(`${BASE}/by-case/${caseId}`);
  return response.data;
};
